import React, { Component } from 'react';
import { View, Image, Text, TouchableOpacity, TouchableWithoutFeedback, StyleSheet } from 'react-native';
import QImageSet from '../../../assets/QImageSet';

interface Props {
    bubbleImage?: string;
    bubbleText?: string;
    onPress?(): void;
}


export default class PriceBubble extends Component<Props> {
    render() {
        const { bubbleImage, bubbleText, bigBubbleImage } = this.props;

        if (Boolean(bubbleText)) {
            return (<TouchableOpacity
                hitSlop={{
                    left: 5,
                    right: 5,
                    top: 5,
                    bottom: 5
                }}
                onPress={this.props.onPress}
            >
                <View style={styles.priceBubbleContainer}>
					<View style={styles.bgImageContainer}>
						<Image style={styles.bgImageLeft} source={{uri: QImageSet.price_bubble_bg_left}}/>
						<Image style={styles.bgImageMiddle} source={{uri: QImageSet.price_bubble_bg_middle}}/>
						<Image style={styles.bgImageRight} source={{uri: QImageSet.price_bubble_bg_right}}/>
					</View>
					<Text style={styles.bubbleText}>
						{bubbleText}
					</Text>
                </View>
            </TouchableOpacity>);
        } else if (Boolean(bubbleImage)) {
            return (<TouchableWithoutFeedback
                hitSlop={{
                    left: 5,
                    right: 5,
                    top: 5,
                    bottom: 5
                }}
                onPress={this.props.onPress}
            >
                <Image source={{ uri: bubbleImage }} style={styles.priceBubbleImage} />
				
            </TouchableWithoutFeedback>);
        } else if (Boolean(bigBubbleImage)) {
            return (
                <View style={styles.bigPriceBubbleContainer}>
                    <View style={{ width: 116 }} />
                    <TouchableWithoutFeedback
                        style={styles.bigPriceBubble}
                        hitSlop={{
                            left: 5,
                            right: 5,
                            top: 5,
                            bottom: 5
                        }}
                        onPress={this.props.onPress}
                    >
                        <View style={styles.bigPriceBubbleBox}>
                            <Image source={{ uri: bigBubbleImage }} style={styles.bigPriceBubbleImage} />
                        </View>
                    </TouchableWithoutFeedback>
                </View>
            )
        }
        return null;
    }
}


const styles = StyleSheet.create({
    bigPriceBubbleContainer:{
        alignItems: 'flex-end',
    },
    bigPriceBubble: {
        position: 'absolute',
        bottom: -20,
        right: 0,
        alignItems: 'center',
        justifyContent: 'center',
        width: 100,
        height: 21
    },
    bigPriceBubbleBox: {
        width: 100,
        height: 21,
        alignItems: 'center',
        justifyContent: 'center',
    },
    bigPriceBubbleImage: {
        width: '100%',
        height: '100%'
    },
    priceBubbleImage: {
        height: 20,
        width: 84,
        resizeMode: 'stretch'
    },
    priceBubbleContainer: {
        height: 20,
    },
    bgImageContainer: {
        flexDirection: 'row',
        position: 'absolute',
        width: '100%',
        height: '100%'
    },
    bgImageLeft: {
        width: 22,
        height: 20,
		resizeMode: 'stretch',
		// backgroundColor: 'red',
    },
    bgImageMiddle: {
        height: 20,
        flex: 1,
        resizeMode: 'stretch',
    },
    bgImageRight: {
        width: 25,
        height: 20,
		resizeMode: 'stretch',
		// backgroundColor: 'blue',
    },
    bubbleText: {
		backgroundColor: 'transparent',
		marginTop: 5,
		height: 18,
		textAlign: 'center',
        fontSize: 10,
        color: 'white',
        marginLeft: 24,
        marginRight: 5
    }

});